import React, { useEffect } from 'react';
import { track } from '../tracking';

const PrescriptionPDFPreview: React.FC<{ id: string }> = ({ id }) => {
    useEffect(() => {
        track('ERROR', { id, on: 'LocalPagedPrescriptionPDFPreview' });
    }, [id]);
    return (
        <div style={{ zoom: 0.8 }} className="w-full bg-white" id="preview">
            Something went wrong, please contact support.
        </div>
    );
};

export default PrescriptionPDFPreview;
